import axios from '@/utils/request'

/**
 * @description  审核管理-待审核的-分页获取模板列表
 * @param params
 * pageSize 分页查询每页数据条数 
 * pageNum 分页查询第X页
 * keyword 检索关键词
 * orderColumn 排序字段
 * order 按何顺序
 * @returns
 */
export async function getTableDataToApplied(params) {
  return axios.get(`/v2/feedback/auditList`,{params})
}

/**
 * @description  审核管理-我申请的-分页获取模板列表
 * @param params
 * pageSize 分页查询每页数据条数 
 * pageNum 分页查询第X页
 * keyword 检索关键词
 * orderColumn 排序字段
 * order 按何顺序
 * @returns
 */
 export async function getTableDataToPreview(params) {
  return axios.get(`/v2/feedback/myApplyList`,{params})
}

/**
 * @description  审核管理-我审核的-分页获取模板列表
 * @param params
 * pageSize 分页查询每页数据条数 
 * pageNum 分页查询第X页
 * keyword 检索关键词
 * orderColumn 排序字段
 * order 按何顺序
 * @returns
 */
 export async function getTableDataToReview(params) {
  return axios.get(`/v2/feedback/auditedList`,{params})
}

/**
 * @description  审核管理-预警审核详情
 * @param params
 * id 预警id
 * @returns
 */
 export async function getForewarningDetail(params) {
  return axios.get(`/v2/feedback/api/forewarning/detail?id=${params.id}&view=${params.view}`)
}

/**
 * @description  审核管理-调研审核详情
 * @param params
 * id 调研id
 * @returns
 */
 export async function getFeedbackDetail(params) {
  return axios.get(`/v2/feedback/api/research/detail?id=${params.id}&view=${params.view}`)
}

/**
 * @description  审核管理-数据订阅详情
 * @param params
 * id 调研id
 * @returns
 */
 export async function getSubscribeDetail(params) {
  return axios.get(`/v2/feedback/subscribe/detail?id=${params.id}&isDraft=${params.isDraft}`)
}


/**
 * @description  审核管理-撤回审核
 * @param params
 * auditId 审核id
 * sourceType	 3调研 4预警
 * sourceId 资源id
 * @returns
 */
 export async function auditRecall(params) {
  return axios.put(`/v2/feedback/auditRecall?auditId=${params.auditId}`)
}

/**
 * @description  审核管理-审批
 * @param params
 * id 审核id
 * audit 0：驳回；1：通过
 * auditAdvice 审批意见
 * @returns
 */
 export async function doAudit(params) {
  return axios.post(`/v2/feedback/audit`,params)
}


// 审核节点
 export async function getAuditDetail(params) {
  return axios.get(`/v2/feedback/auditDetail?id=${params.id}&sourceType=${params.sourceType}`)
}


// 审核浮窗
export async function getAuditPopover(params) {
  return axios.get(`/v2/feedback/auditDetail?sourceId=${params.sourceId}&sourceType=${params.sourceType}`)
}
